import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { BaseApi } from '@/api/base-api';
import type { GameStateResponse } from '@/api/response/games/game-state.response';


export class GamesCatalogApi extends BaseApi {
  private controller = '/common/catalog';

  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  public async gameStates(gameId: string): Promise<GameStateResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/games/${gameId}/states`,
      {},
    );
  }
}
